import { useState } from 'react'
import { Trans } from '@lingui/macro'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'

import { PatientProfileForm } from '@/features/patient/patient-profile-form'
import { useLanguage } from '@/hooks/useLanguage'
import { CGUDialog, shouldShowCgu } from '@/pages/create-patient'
import { SelectedPatient } from '../model/useSimplifiedReception'

type NewPatientStepProps = { onCreated: (patient: SelectedPatient) => void; onCancel: () => void }

/** The usual patient creation form (same rules and checks), without leaving the reception screen. */
export function NewPatientStep({ onCreated, onCancel }: NewPatientStepProps) {
  const language = useLanguage()
  const [cguOpen, setCguOpen] = useState(shouldShowCgu(language))

  return (
    <>
      <PatientProfileForm
        mode="create"
        onCreated={(patientId, patient) => onCreated({ id: patientId, label: `${patient.userInfo.name} ${patient.userInfo.surname}` })}
        action={({ isSubmitting }) => (
          <Stack direction="row" justifyContent="end">
            <LoadingButton disabled={cguOpen} loading={isSubmitting} size="large" type="submit" variant="contained">
              <Trans>Create the patient</Trans>
            </LoadingButton>
          </Stack>
        )}
      />
      <CGUDialog open={cguOpen} onClose={() => setCguOpen(false)} onRefuse={onCancel} />
    </>
  )
}
